import { DateTime } from "luxon";

// This renewal date calculation also occurs on the backend under the RenewalCalculator
// ny updates here to the calculation, should also be reflected in the backend RenewalCalculator
export const calculateNextRenewalDate = (
  startDate: DateTime,
  periodInMonths: number
) => {
  const originalDay = startDate.day;
  let nextRenewalDate = startDate;
  let loopCount = 0;

  while (nextRenewalDate <= DateTime.now()) {
    nextRenewalDate = nextRenewalDate.plus({ months: periodInMonths });

    const daysInMonth = DateTime.local(
      nextRenewalDate.year,
      nextRenewalDate.month
    ).daysInMonth!;
    if (originalDay > daysInMonth) {
      nextRenewalDate = nextRenewalDate.set({ day: daysInMonth });
    } else {
      nextRenewalDate = nextRenewalDate.set({ day: originalDay });
    }

    loopCount++;
  }

  return {
    nextRenewalDate,
    isForcedToFuturePeriodDate: loopCount > 1 // Indicates whether the renewal date has been further increased due to being in the past still. A renewal date MUST be in the future.
  };
};
